<page-section sectionTitle="Testimonials">
  <p>
    testimonials works!
  </p>
</page-section>
